import * as z from 'zod';
import { testSchoolEmail } from '../util';
import { ErrorMessages } from './error-messages';

export const waitlistFormSchema = z
  .object({
    firstName: z.string().nonempty(ErrorMessages.Required),
    lastName: z.string().nonempty(ErrorMessages.Required),
    email: z
      .string()
      .email(ErrorMessages.Email.INVALID_SCHOOL)
      .refine(val => testSchoolEmail(val), ErrorMessages.Email.MUST_BE_EDU),
  })
  .refine(({ firstName, lastName }) => firstName && lastName, {
    message: ErrorMessages.Name.MISSING,
    path: ['fullName'],
  });

export type WaitlistFormData = z.TypeOf<typeof waitlistFormSchema>;
